import { render, staticRenderFns } from "./SlideShowShops.vue?vue&type=template&id=cd58531e&scoped=true&"
import script from "./SlideShowShops.vue?vue&type=script&lang=js&"
export * from "./SlideShowShops.vue?vue&type=script&lang=js&"
import style0 from "./SlideShowShops.vue?vue&type=style&index=0&id=cd58531e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd58531e",
  null
  
)

export default component.exports